import React from 'react';
export const DocumentsWithPhone = () => (
  <svg width="201px" height="160px" viewBox="0 0 201 160" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-228.000000, -1224.000000)">
        <g transform="translate(228.000000, 1224.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M67.5093,94.9652 C67.5093,94.9652 57.8413,75.8652 61.6643,65.3122 C67.2623,49.8592 91.2763,50.0762 89.8293,65.4122 C88.9003,75.2632 77.1413,77.3222 81.8233,85.5542"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M174.1885,152.5151 L142.4435,152.5151"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M55.3575,152.5151 L36.6015,152.5151"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.6011,152.5151 L18.5651,152.5151"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="113.6392 111.6381 105.9392 112.8851 107.0022 121.6761"
          />
          <path
            d="M114.5342,155.2514 C114.5342,157.3364 107.1692,159.0254 98.0852,159.0254 C89.0002,159.0254 81.6362,157.3364 81.6362,155.2514 C81.6362,153.1664 89.0002,151.4774 98.0852,151.4774 C107.1692,151.4774 114.5342,153.1664 114.5342,155.2514"
            fill="#D0D7DA"
          />
          <polygon
            fill="#FCFCFC"
            points="81.1836 125.81 78.6186 79.953 113.2686 77.831 115.8466 123.876"
          />
          <polygon
            stroke="#E2E8EE"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.1836 125.81 78.6186 79.953 113.2686 77.831 115.8466 123.876"
          />
          <polygon
            fill="#FCFCFC"
            points="107.4512 118.434 79.6682 122.931 72.3412 78.804 106.6112 73.257 112.8382 110.584"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="107.4512 118.434 79.6682 122.931 72.3412 78.804 106.6112 73.257 112.8382 110.584"
          />
          <polygon
            fill="#0B9CE5"
            points="86.8711 81.0541 76.7181 82.9521 78.3951 91.9301 88.5491 90.0321"
          />
          <path
            d="M103.335,87.4594 L92.838,89.1634 C92.06,89.2934 91.316,88.7634 91.186,87.9834 C91.056,87.2054 91.587,86.4624 92.365,86.3324 L102.862,84.6274 C103.641,84.4974 104.384,85.0284 104.514,85.8074 C104.645,86.5854 104.114,87.3294 103.335,87.4594"
            fill="#DDE5E8"
          />
          <path
            d="M104.543,94.4233 L81.655,98.0743 C80.876,98.2043 80.133,97.6743 80.003,96.8953 C79.873,96.1163 80.404,95.3733 81.183,95.2433 L104.07,91.5923 C104.849,91.4613 105.592,91.9923 105.722,92.7713 C105.852,93.5503 105.321,94.2933 104.543,94.4233"
            fill="#DDE5E8"
          />
          <path
            d="M105.8355,101.4106 L82.9475,105.0616 C82.1685,105.1916 81.4255,104.6616 81.2955,103.8826 C81.1655,103.1036 81.6965,102.3606 82.4755,102.2306 L105.3625,98.5796 C106.1415,98.4486 106.8845,98.9796 107.0145,99.7586 C107.1445,100.5376 106.6135,101.2806 105.8355,101.4106"
            fill="#DDE5E8"
          />
          <path
            d="M108.1128,108.4477 L85.2258,112.0987 C84.4468,112.2287 83.7028,111.6977 83.5728,110.9197 C83.4438,110.1407 83.9738,109.3967 84.7528,109.2667 L107.6398,105.6157 C108.4188,105.4857 109.1628,106.0167 109.2928,106.7957 C109.4228,107.5737 108.8918,108.3167 108.1128,108.4477"
            fill="#DDE5E8"
          />
          <polyline
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="112.2661 110.5004 106.3571 111.4564 107.4511 118.4344"
          />
          <polygon
            fill="#F2F3F3"
            points="86.6773 112.0131 74.1073 117.2861 72.7483 91.1011 77.2213 89.8731"
          />
          <polygon
            fill="#FFFFFF"
            points="83.9082 110.4828 66.7822 117.6678 56.7802 93.8258 73.9062 86.6408"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="83.9082 110.4828 66.7822 117.6678 56.7802 93.8258 73.9062 86.6408"
          />
          <g transform="translate(68.000000, 104.710000)">
            <path d="M0.1866,4.5824 L8.7176,0.8864" fill="#FCFCFC" />
            <path
              d="M0.1866,4.5824 L8.7176,0.8864"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(65.000000, 88.710000)">
            <path d="M0.0108,0.515 L1.5558,3.883" />
            <path
              d="M0.0108,0.515 L1.5558,3.883"
              stroke="#042F43"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#DDE5E8"
            points="75.73 102.5365 66.844 106.2655 63.116 97.3785 72.002 93.6505"
          />
          <path
            d="M125.9522,129.7719 L114.7022,124.7539 C114.3372,124.5919 114.1742,124.1649 114.3362,123.7989 L124.2162,101.6489 C124.3792,101.2839 124.8062,101.1209 125.1712,101.2829 L136.4212,106.2999 C136.7852,106.4629 136.9492,106.8909 136.7862,107.2549 L126.9072,129.4069 C126.7442,129.7709 126.3162,129.9349 125.9522,129.7719"
            fill="#FFFFFF"
          />
          <path
            d="M125.9522,129.7719 L114.7022,124.7539 C114.3372,124.5919 114.1742,124.1649 114.3362,123.7989 L124.2162,101.6489 C124.3792,101.2839 124.8062,101.1209 125.1712,101.2829 L136.4212,106.2999 C136.7852,106.4629 136.9492,106.8909 136.7862,107.2549 L126.9072,129.4069 C126.7442,129.7709 126.3162,129.9349 125.9522,129.7719 Z"
            stroke="#757575"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#333333"
            points="127.791 126.1684 116.118 120.9624 123.837 103.6564 135.51 108.8624"
          />
          <path
            d="M121.4605,125.3236 C121.3215,125.6356 120.9565,125.7746 120.6445,125.6356 C120.3325,125.4966 120.1925,125.1316 120.3315,124.8196 C120.4705,124.5086 120.8355,124.3686 121.1485,124.5076 C121.4595,124.6456 121.5995,125.0116 121.4605,125.3236"
            fill="#C3D3D8"
          />
          <path
            d="M138.1548,101.8764 L139.7908,98.0224"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M141.7608,109.4467 L145.6158,111.0827"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M141.9151,105.1137 L145.9501,103.5427"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M51.2124,82.4848 L51.2124,83.7998"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M51.2124,86.432 L51.2124,87.747"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M53.8438,85.1156 L52.5278,85.1156"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M49.8965,85.1156 L48.5815,85.1156"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M125.0025,69.4985 L125.0025,70.8135"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M125.0025,73.4447 L125.0025,74.7607"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M127.6338,72.1293 L126.3188,72.1293"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M123.687,72.1293 L122.371,72.1293"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M130.9712,81.5248 C130.9712,82.0068 130.5802,82.3988 130.0972,82.3988 C129.6152,82.3988 129.2232,82.0068 129.2232,81.5248 C129.2232,81.0418 129.6152,80.6508 130.0972,80.6508 C130.5802,80.6508 130.9712,81.0418 130.9712,81.5248"
            fill="#0B9CE5"
          />
          <path
            d="M98.4825,73.5512 L98.4235,73.1882 C98.2985,72.4272 98.7905,71.7072 99.5155,71.5882 C100.2405,71.4702 100.9365,71.9952 101.0605,72.7572 L101.5245,75.5932 C101.6485,76.3552 101.1565,77.0742 100.4315,77.1932 C99.7065,77.3122 99.0115,76.7852 98.8865,76.0252"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M84.1773,85.9389 C84.1663,86.8699 83.4023,87.6159 82.4703,87.6049 C81.5393,87.5929 80.7933,86.8289 80.8043,85.8969 C80.8163,84.9659 81.5803,84.2199 82.5113,84.2319 C83.4433,84.2429 84.1893,85.0069 84.1773,85.9389"
            fill="#FFFFFF"
          />
          <path
            d="M80.564,90.3471 L86.068,89.3311 C86.068,89.3311 85.58,86.8321 82.893,87.2711 C80.206,87.7081 80.564,90.3471 80.564,90.3471"
            fill="#FFFFFF"
          />
          <path
            d="M82.2456,86.7797 C82.2456,86.7797 82.3946,86.8787 82.6816,86.8387 C82.9686,86.7987 83.1046,86.5867 83.1046,86.5867"
            stroke="#0B9CE5"
            strokeWidth="0.5"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
